<myclubrewards-carousel></myclubrewards-carousel>
<myclubrewards-locations></myclubrewards-locations>
<myclubrewards-rewards></myclubrewards-rewards>